export const ROW_STATUS_KEY = "__rowStatus";

export const ROW_STATUS = {
  LOADING: "loading",
  SUCCESS: "success",
  ERROR: "error",
};

export const readCache = (storageKey) => {
  try {
    const cached = sessionStorage.getItem(storageKey);
    if (cached) {
      return JSON.parse(cached);
    }
  } catch (error) {
    console.error("Error reading aggregated summary list cache:", error);
  }
  return null;
};

export const writeCache = (storageKey, data) => {
  try {
    sessionStorage.setItem(storageKey, JSON.stringify(data));
  } catch (error) {
    console.error("Error writing aggregated summary list cache:", error);
  }
};

export const sumColumn = (rows, columnAccessor) => {
  if (!columnAccessor || !Array.isArray(rows)) {
    return 0;
  }
  return rows.reduce((sum, row) => {
    if (row[ROW_STATUS_KEY] === ROW_STATUS.LOADING || row[ROW_STATUS_KEY] === ROW_STATUS.ERROR) {
      return sum;
    }
    const value = Number(row[columnAccessor]);
    return sum + (Number.isFinite(value) ? value : 0);
  }, 0);
};
